<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择部门"
    clearable
    filterable
  >
    <el-option
      v-for="item in departmentList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'DepartmentLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      departmentList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      // 返回选中对象的完整信息
      this.$emit('callBack', this.departmentList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchDepartmentList()
  },
  methods: {
    async fetchDepartmentList() {
      try {
        const res = await requestTicket.post('/Ticketing/department/findAll')
        this.departmentList = res.data || []
      } catch (error) {
        console.error('获取部门列表失败:', error)
      }
    }
  }
}
</script>